import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownSelect, FieldWrapper, FlexBox, InputText, SelectItem, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { useDebounce } from 'react-use';
import { messengerLanguages, } from 'components/settings/components/sections/dixaMessenger/views/appearance/components/generalSettings/languageSettings/languages';
import styles from './translateString.module.scss';
const items = messengerLanguages.map(({ code, label }) => ({
    id: code,
    name: label,
}));
const makeInputDescription = (value, maxCharacters) => {
    const charactersLeft = Math.max(maxCharacters - value.length, 0);
    return `${charactersLeft} ${charactersLeft === 1 ? 'character' : 'characters'} left`;
};
/**
 * Dropdown language selection with input field for adding / editing string
 * translations
 */
export function TranslateString({ selectedLanguage, inputLabel, translatedString, placeholder, onLanguageSelect, onInputChange, }) {
    var _a;
    const selectedItem = items.find((x) => x.id === selectedLanguage);
    const [debouncedValue, setDebouncedValue] = useState((_a = translatedString.translatedMap[selectedLanguage]) !== null && _a !== void 0 ? _a : '');
    useDebounce(() => onInputChange(debouncedValue), 150, [debouncedValue]);
    const inputDescription = makeInputDescription(debouncedValue, translatedString.maxLength);
    const handleOnInputChange = (ev) => {
        const { value } = ev.target;
        if (value.length <= translatedString.maxLength) {
            setDebouncedValue(ev.target.value);
        }
        else {
            setDebouncedValue(ev.target.value.substring(0, translatedString.maxLength));
        }
    };
    return (_jsxs(FlexBox, Object.assign({ gap: "300", alignItems: "center", margin: "300 0 0" }, { children: [_jsx(FieldWrapper, Object.assign({ label: "Language", className: styles.fieldWrapper }, { children: _jsx(DropdownSelect, Object.assign({ buttonProps: {
                        className: styles.selectButton,
                        styleText: false,
                    }, items: items, itemComponent: SelectItem, selectedItems: selectedItem ? [selectedItem.id] : [], onSelect: (x) => onLanguageSelect(x.id), noArrow: false }, { children: selectedItem ? selectedItem.name : 'Select Item' })) })), _jsx(FieldWrapper, Object.assign({ label: inputLabel, description: inputDescription, className: styles.fieldWrapper }, { children: _jsx(InputText, { className: styles.input, value: debouncedValue, onChange: handleOnInputChange, placeholder: placeholder }) }))] })));
}
